<template>
	<AppModal
		ref="linkButtonModal"
		:title="isEdit ? 'Edit Button' : 'Add a Link Button'"
		class-name="block-modal fade"
		:close-button="false"
		:backdrop="false"
	>
		<div class="d-flex-column justify-content-left">
			<div class="w-100 mb-3">
				<AppInput v-model.trim="buttonTitle" icon="/images/icons/ic-edit.svg" class="form-group" placeholder="Button text" maxlength="30" />
			</div>

			<div class="w-100">
				<AppInput
					v-model.trim="buttonUrl"
					icon="/images/icons/ic-link.svg"
					:class="{ 'form-error': urlError }"
					class="form-group"
					placeholder="https://..."
				/>
				<div v-if="urlError" class="text-sm stan-text-danger mt-1">
					Please enter a valid link
				</div>
			</div>
		</div>

		<p v-if="!isEdit" class="text-light float-right mt-2 para-3">
			<i>Adding a link button disables plain text links</i>
		</p>

		<div class="w-100 d-flex justify-content-end mt-4">
			<div class="button-group">
				<AppButton v-if="isEdit" name="link-button-modal-remove-button" outline class="mr-2" @click="removeButton">
					Remove Button
				</AppButton>
				<AppButton name="link-button-modal-save-button" :disabled="!isValid" @click="handleSave">
					{{ isEdit ? 'Save' : 'Add' }}
				</AppButton>
			</div>
		</div>
	</AppModal>
</template>

<script>
	import commonHelper from '~/global_helper/helpers.js'

	export default {
		name: 'LinkButtonModal',
		data() {
			return {
				buttonTitle: '',
				buttonUrl: '',
				isEdit: false,
				urlError: false,
			}
		},
		computed: {
			isValid() {
				return this.buttonTitle.trim().length > 0 && this.buttonUrl.trim().length > 0 && !this.urlError
			},
		},
		watch: {
			buttonUrl() {
				this.urlError = false
			},
		},
		methods: {
			show(data = null) {
				if (data) {
					this.isEdit = true
					this.buttonTitle = data.title || ''
					this.buttonUrl = data.url || ''
				} else {
					this.isEdit = false
					this.buttonTitle = ''
					this.buttonUrl = ''
				}
				this.$refs.linkButtonModal.show()
			},
			hide() {
				this.$refs.linkButtonModal.hide()
			},
			handleSave() {
				if (!this.isValid) return

				// Validate URL format
				if (!this.isValidUrl(this.buttonUrl)) {
					this.urlError = true
					return
				}

				const buttonData = {
					title: this.buttonTitle,
					url: commonHelper.autoAddHttps(this.buttonUrl),
					type: 'web_url', // Required for Facebook API integration
				}

				this.$emit('save', buttonData)
				this.hide()
			},
			removeButton() {
				this.$emit('remove')
				this.hide()
			},
			isValidUrl(url) {
				if (!url) return false
				if (commonHelper.isValidURL(url) || commonHelper.isValidURLWithoutHttp(url)) {
					this.urlError = false
					return true
				}
				this.urlError = true
				return false
			},
		},
	}
</script>

<style lang="scss" scoped>
	.button-group {
		display: flex;
		gap: 10px;
	}
</style>
